import rosterEmptyUrl from './rosterEmptyComponent.html';
export default {
  templateUrl: rosterEmptyUrl,
  controller(RosterService) {
    'ngInject';

    this.RosterService = RosterService;
  },
  controllerAs: 'ctrl',
  bindings: {
    showResetFilters: '<',
    clearFilters: '&',
    date: '<',
    hasShiftsWithinTwoWeeks: '<',
  },
};
